import { withDefaultCurrency } from 'common/utils/formatUtils';
import { CreditCardProductFragment, CreditCardProductInput, ProductStatus } from 'generated/graphql';

export type MapCreditCardProductToInput = (product?: CreditCardProductFragment) => CreditCardProductInput;

export const mapCreditCardProductToInput: MapCreditCardProductToInput = (
  product = {
    creationTimestamp: new Date(),
    documents: [],
    enableFinancialAdvisorCare: true,
    enableNotifications: true,
    id: '',
    status: ProductStatus.Active,
    statusChangeDate: new Date(),
  },
) => {
  return {
    contractEndDate: product.contractEndDate,
    contractNumber: product.contractNumber,
    contractSignDate: product.contractSignDate,
    enableFinancialAdvisorCare: product.enableFinancialAdvisorCare,
    enableNotifications: product.enableNotifications,
    institutionId: product.institution?.id,
    institutionName: product.institutionName,
    limitAmount: withDefaultCurrency(product.limitAmount),
    name: product.name,
    note: product.note,
    owedAmountPaidByMaturity: product.owedAmountPaidByMaturity,
    paymentInfo: {
      constantSymbol: product.paymentInfo?.constantSymbol,
      ibanForPayment: product.paymentInfo?.ibanForPayment,
      specificSymbol: product.paymentInfo?.specificSymbol,
      variableSymbol: product.paymentInfo?.variableSymbol,
    },
    paymentPeriod: {
      expectedAmount: withDefaultCurrency(product.paymentPeriod?.expectedAmount),
      periodCount: product.paymentPeriod?.periodCount,
      periodTypeCode: product.paymentPeriod?.periodTypeCode,
      referenceDate: product.paymentPeriod?.expectedDate,
    },
    regularUsage: product.regularUsage,
    status: product.status,
    statusChangeDate: product.statusChangeDate,
  };
};
